import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface LivenessCredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  expiration: string;
  region: string;
}

export interface LivenessResult {
  livenessConfidence: number;
  similarity: number | null;
  decision: 'pass' | 'fail';
  reason: string;
}

/** Talks to the three recovery-liveness lambda endpoints. */
@Injectable({ providedIn: 'root' })
export class RecoveryLivenessService {
  private readonly base = environment.lambdaUrl.replace(/\/$/, '');

  constructor(private http: HttpClient) {}

  createSession(): Promise<{ sessionId: string }> {
    return firstValueFrom(
      this.http
        .post<any>(`${this.base}/recovery-liveness-session`, {})
        .pipe(map((r) => r.details)),
    );
  }

  getCredentials(): Promise<LivenessCredentials> {
    return firstValueFrom(
      this.http
        .post<any>(`${this.base}/recovery-liveness-credentials`, {})
        .pipe(map((r) => r.details)),
    );
  }

  getResult(sessionId: string, documentImage: string): Promise<LivenessResult> {
    return firstValueFrom(
      this.http
        .post<any>(`${this.base}/recovery-liveness-result`, { sessionId, documentImage })
        .pipe(map((r) => r.details)),
    );
  }
}
